import styled from 'styled-components';

export const TotalReportsColumHeader = styled.span`
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;
